import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function UserGrowthChart({ data }) {
  return (
    <div style={styles.container}>
      <h3 style={styles.title}>👥 İstifadəçi Artımı (Son 30 gün)</h3>
      
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }}
            stroke="#999"
          />
          <YAxis 
            tick={{ fontSize: 12 }}
            stroke="#999"
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '10px',
            }}
          />
          <Line 
            type="monotone" 
            dataKey="users" 
            stroke="#FF6B35" 
            strokeWidth={3}
            dot={{ fill: '#FF6B35', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '20px',
  },
};

export default UserGrowthChart;